module.exports = __webpack_public_path__ + "images/7_NOON_partners.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/7_NOON_partners.jpg
// module id = 264
// module chunks = 0